module.exports = __webpack_public_path__ + "static/img/gj001.2104b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/projectApplication/gj001.png
// module id = VIAR
// module chunks = 1